import ExpandMoreRoundedIcon from '@mui/icons-material/ExpandMoreRounded';
import {
	FormControl,
	Grid,
	InputLabel,
	MenuItem,
	Select,
	SelectChangeEvent,
} from '@mui/material';

import { LANDING_PAGE_DROPDOWN_TYPE } from 'common/constants/TaxonomyConstants';
import { toSentenceCase } from 'common/utils/utilFunctions';

import { IDataBaseOptionsResponse, IIsApiLoading } from '../../api/type-def';

import styles from './PRCInventoryLandingHeaderDropDown.module.scss';

interface IPRCInventoryLandingHeaderDropDownProps {
	type: LANDING_PAGE_DROPDOWN_TYPE;
	value: string;
	handleOptionClick: (event: SelectChangeEvent<string>) => void;
	isApiLoading: IIsApiLoading;
	optionList: IDataBaseOptionsResponse[];
}

const { labelColor } = styles;

const PRCInventoryLandingHeaderDropDown = (
	props: IPRCInventoryLandingHeaderDropDownProps,
) => {
	const { type, value, handleOptionClick, isApiLoading, optionList } = props;

	return (
		<Grid item>
			<FormControl variant="filled" className={styles['prc-landing-dropdown']}>
				<InputLabel
					data-testid={`${type}-label`}
					className={styles['prc-landing-dropdown-label']}
					id={`${type}-label-input-id`}
					sx={{
						'&.Mui-focused': {
							color: labelColor,
						},
					}}
				>
					{toSentenceCase(type)}
				</InputLabel>
				<Select
					labelId={`${type}-label-input-id`}
					className={styles['prc-landing-dropdown-select']}
					value={value}
					onChange={handleOptionClick}
					IconComponent={ExpandMoreRoundedIcon}
					inputProps={{
						'data-testid': `${type}-test-id`,
					}}
					disabled={isApiLoading.count}
				>
					{optionList.map(({ label, value, id, active }) => (
						<MenuItem value={value} key={id} disabled={!active}>
							{label}
						</MenuItem>
					))}
				</Select>
			</FormControl>
		</Grid>
	);
};

export default PRCInventoryLandingHeaderDropDown;
